import React, { useCallback, useEffect, useRef } from "react";

export interface FileUploadInterface {
    collection: string;
    fileName: string | undefined;
    fileChange: (file: File, collection: string) => void;
}

export function FileUpload({ fileChange, collection, fileName, }: FileUploadInterface) {

    const fileInputRef: React.RefObject<HTMLInputElement> = useRef();

    useEffect(() => {
        if (!fileName?.trim() && fileInputRef?.current) {
            fileInputRef.current.value = '';
        }
    }, [fileName]);

    const handleBrowseClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = useCallback((event: any) => {
        if (event.target.files[0]) {
            fileChange(event.target.files[0], collection);
        }
    }, [fileChange, collection]);

    return (
        <div className="form-group">
            <input type="file" ref={fileInputRef} className="custom-file-input" id="inputGroupFile" accept="application/JSON" onChange={handleFileChange} style={{ display: 'none' }} />
            <div className="input-group">
                <input type="text" value={fileName ?? ''} className="form-control" placeholder={`Choose ${collection} file`} readOnly onClick={handleBrowseClick} />
                <span className="input-group-btn">
                    <button className="btn btn-primary" type="button" title="Browse" onClick={handleBrowseClick}>
                        <span className="glyphicon glyphicon-search" />
                    </button>
                </span>
            </div>
        </div>
    );
}